
//
// ランダムの並び替え
//////////////////////////////////////////////////////////////////

function shuffleContent(container) {
  var content = container.find("> *");
  var total = content.length;
  content.each(function() {
    content.eq(Math.floor(Math.random() * total)).prependTo(container);
  });
}
$(function() {
  shuffleContent($(".rndm_prod"));
  shuffleContent($(".rndm_pick"));
  shuffleContent($(".rndm_series"));
  shuffleContent($(".rndm_ctr"));
  shuffleContent($(".rndm_sol"));
  shuffleContent($(".rndm_co"));
  shuffleContent($(".rndm_sprt"));
  shuffleContent($(".rndm_csr"));
  shuffleContent($(".rndm_topmenu1"));
  shuffleContent($(".rndm_topmenu2"));
  shuffleContent($(".rndm_topmenu3"));
  shuffleContent($(".rndm_topmenu4"));
});

//
// topslider
//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.top_slider', {
  loop: true,
	centeredSlides : true,
  breakpoints: {
    768: { slidesPerView: 1 },
    1024: { slidesPerView: 1.1 },
    1280: { slidesPerView: 1.3 },
    1920: { slidesPerView: 1.75 },
    2560: { slidesPerView: 1.75 }
	},
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoplay: {
    delay: 7000
  }
});


var swiper = new Swiper('.top-slider-cont', {
  loop: true,
  speed: 300,
	centeredSlides : true,
  //spaceBetween: -30,
  breakpoints: {
    360:  { slidesPerView: 1.1, spaceBetween: 10, },
    1024: { slidesPerView: 1.3 },
    1280: { slidesPerView: 1.5 },
    1920: { slidesPerView: 1.75 }
	},
  /*pagination: {
    el: '.swiper-pagination',
    type: 'progressbar'
  },*/
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    spaceBetween: 40,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoplay: {
    delay: 10000,
    //disableOnInteraction: true,
  },
  on: {
    slideChange: function () {
      if (this.realIndex > 0) {
        this.params.autoplay.delay = 9700
      }
    },
  },
});

//画像の読み込みが完了してからSwiperを初期化
window.addEventListener('load', () => {
  const swiper = new Swiper('.top-slider-cont2', {
    loop: true,
    speed: 300,
    centeredSlides : true,
    //spaceBetween: -30,
    breakpoints: {
      360:  { slidesPerView: 1.1, spaceBetween: 10, },
      768:  { slidesPerView: 1.5 },
      1024: { slidesPerView: 2 },
      1280: { slidesPerView: 3.25 },
      1440: { slidesPerView: 3 },
      1920: { slidesPerView: 3.25 },
      1921: { slidesPerView: 4.35 }
    },
    /*pagination: {
      el: '.swiper-pagination',
      type: 'progressbar'
    },*/
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      spaceBetween: 40,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay: {
      delay: 10000,
      //disableOnInteraction: true,
    },
    // 画像のプリロードを防ぎ、レイアウト崩れを軽減
    preloadImages: false,
    //DOMの変更を監視、レイアウト再計算
    observer: true,
    observeParents: true,
    // 初期化時にスライドのサイズを設定
    on: {
      init: function () {
        this.slides.forEach(slide => {
          slide.style.width = `${this.width}px`;
        });
      },
    },
    // delay設定
    on: {
      slideChange: function () {
        if (this.realIndex > 0) {
          this.params.autoplay.delay = 9700
        }
      },
    },
  });
});


//
// top_carousel
//////////////////////////////////////////////////////////////////

$(function(){
  var rand_obj         = $(".rndm_carousel");
  var rand_child_obj   = rand_obj.find("> *");
  var rand_child_total = rand_child_obj.size();
  rand_child_obj.each(function() {
      var num = Math.floor(Math.random()*rand_child_total);
      rand_child_obj.eq(num).prependTo(rand_obj);
  });
});

/*var swiper = new Swiper('.menu_carousel', {
  breakpoints: {
    360: { slidesPerView: 2, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    768: { slidesPerView: 3.5, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 3, spaceBetween: 30, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 3.5, spaceBetween: 30, slidesOffsetBefore: 50, }, // pc
    1400: { slidesPerView: 3.5, spaceBetween: 43, slidesOffsetBefore: 50, }, // pc
    1600: { slidesPerView: 4.5, spaceBetween: 43, slidesOffsetBefore: 50, }, // pc
    1920: { slidesPerView: 4.5, spaceBetween: 43, slidesOffsetBefore: 50, } // wpc3
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  },
  //grabCursor: true,
  //effect: "creative",
  //: {
  //  prev: {
//origin: "center left",
  //    translate: ["120%", 0, 200],
  //    rotate: [0, -100, 0],
  //  },
  //  next: {
  //    origin: "center right",
  //    translate: ["50%", 0, 200],
  //    rotate: [0, 100, 0],
  //  },
  //},
});
var swiper = new Swiper('.menu_carousel2', {
  breakpoints: {
    360: { slidesPerView: 2, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    768: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 5.5, spaceBetween: 30, slidesOffsetBefore: 50, }, // pc
    1400: { slidesPerView: 5.5, spaceBetween: 43, slidesOffsetBefore: 50, }, // pc
    1920: { slidesPerView: 6.5, spaceBetween: 43, slidesOffsetBefore: 50, } // wpc3
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  },
  grabCursor: true,
  effect: "creative",
  creativeEffect: {
    prev: {
      origin: "center left",
      translate: ["120%", 0, 200],
      rotate: [0, -100, 0],
    },
    next: {
      origin: "center right",
      translate: ["50%", 0, 200],
      rotate: [0, 100, 0],
    },
  },
});*/


var swiper = new Swiper('.menu-carousel', {
    breakpoints: {
    360:  { slidesPerView: 1.15, spaceBetween: 20, slidesOffsetBefore: 20 },
    768:  { slidesPerView: 1.75, spaceBetween: 20, slidesOffsetBefore: 20 },
    1024: { slidesPerView: 2.25, spaceBetween: 20, slidesOffsetBefore: 20 },
    1280: { slidesPerView: 1.75, spaceBetween: 20 },
    1400: { slidesPerView: 2.1,  spaceBetween: 20 },
    1600: { slidesPerView: 2.4,  spaceBetween: 20 },
    1920: { slidesPerView: 2.6,  spaceBetween: 20 }
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  ///: {
  //  delay: 7000
  //},
  loop: true,
});
var swiper = new Swiper('.menu-carousel-sm', {
  breakpoints: {
  375:  { slidesPerView: 1.5, spaceBetween: 20, slidesOffsetBefore: 20 },
  768:  { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 20 },
  1024: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 20 },
  1280: { slidesPerView: 3, spaceBetween: 20 },
  1366: { slidesPerView: 3.5, spaceBetween: 20 },
  1400: { slidesPerView: 3.5,  spaceBetween: 20 },
  1600: { slidesPerView: 4,  spaceBetween: 20 },
  1920: { slidesPerView: 4,  spaceBetween: 20 }
},
navigation: {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev'
},
///: {
//  delay: 7000
//},
//loop: true,
scrollbar: {
  el: '.swiper-scrollbar',
  draggable: true
},
});
const swiperPrev = document.getElementsByClassName('swiper-button-prev-a');
const swiperNext = document.getElementsByClassName('swiper-button-next-a');

for (let i = 0; i < swiperPrev.length; i++) {
  swiperPrev[i].addEventListener('click', (e) => {
    //const parent = e.target.parentNode;
    const parent = e.target.closest('.menu-carousel-blk');
    const prev = parent.getElementsByClassName('swiper-button-prev')[0];
    prev.click();
  });
}

for (let i = 0; i < swiperNext.length; i++) {
  swiperNext[i].addEventListener('click', (e) => {
    //const parent = e.target.parentNode;
    const parent = e.target.closest('.menu-carousel-blk');
    const next = parent.getElementsByClassName('swiper-button-next')[0];
    next.click();
  });
}

//////////////////////////////////////////////////////////////////

// topmeu-carousel

//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.topmenu-carousel-slider', {
  centeredSlides: true,
  loop: true,
  speed: 500,
  slidesPerView: 1.5,
  spaceBetween: 40,
  autoplay: {
      delay: 6000,
  },
  breakpoints: {
    360: { slidesPerView: 1 }
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
$(".topmenu-carousel-slider").hover(function() {
  (this).swiper.autoplay.stop();
}, function() {
  (this).swiper.autoplay.start();
});

var swiper = new Swiper('.footer-carousel-container', {
  breakpoints: {
    360: { slidesPerView: 1.9, spaceBetween: 20, slidesOffsetBefore: 20, }, // tb
    768: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 4, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 50, }, // pc
    1400: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 50, }, // pc
    1600: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 50, }, // pc
    1920: { slidesPerView: 6, spaceBetween: 30, slidesOffsetBefore: 50, } // wpc3
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  },
});

// topmenu-slider

var swiper = new Swiper(
  '.pickup-slider, .pagetop-slider', {
  centeredSlides: true,
  loop: true,
  speed: 500,
  slidesPerView: 1.5,
  //spaceBetween: 40,
  /*autoplay: {
      delay: 3000,
  },*/
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  breakpoints: {
      768:  { slidesPerView: 2 },
      1024: { slidesPerView: 2.5 },
      1280: { slidesPerView: 3 },
      1400: { slidesPerView: 3.5 },
      1600: { slidesPerView: 3.5 },
      1920: { slidesPerView: 4 },
  },
});

//////////////////////////////////////////////////////////////////

// product compare

//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.carousel-compare', {
  breakpoints: {
    360: { slidesPerView: 1.8, spaceBetween: 0, slidesOffsetBefore: 20, }, // tb
    768: { slidesPerView: 2.5, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 3, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 120, }, // pc
    1400: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 100, }, // pc
    1600: { slidesPerView: 5, spaceBetween: 20, slidesOffsetBefore: 100, }, // pc
    1920: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 140, } // wpc3
	},
  /*navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },*/
  //scrollbar: {
  //  el: '.swiper-scrollbar',
  //  draggable: true
  //},
});

//////////////////////////////////////////////////////////////////

// campaign

//////////////////////////////////////////////////////////////////

// ランダムの並び替え
var divsCollection = $(".campaign_banner_wrapper");
var container = $(divsCollection).find('.swiper-slide');
var divs = container.get().sort(function(){
    return Math.round(Math.random());
});
$(divsCollection).html(divs);

/*$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('.campaign_banner', {
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          autoplay: {
            delay: 4000
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      } 
    } 
  });
});*/

var swiper = new Swiper('.campaign_banner', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoplay: {
    delay: 4000
  },
	centeredSlides : false,
  breakpoints: {
    360: { slidesPerView: 1 }
  },
});


var swiper = new Swiper('.loop-slider', {
  breakpoints: {
    360:  { slidesPerView: 2, spaceBetween: 10, slidesOffsetBefore: 20, }, // tb
    768:  { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 4, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 120, }, // pc
    1400: { slidesPerView: 6, spaceBetween: 30, slidesOffsetBefore: 100, }, // pc
    1600: { slidesPerView: 7, spaceBetween: 20, slidesOffsetBefore: 100, }, // pc
    1920: { slidesPerView: 8, spaceBetween: 30, slidesOffsetBefore: 140, }
  },
  loop: true, // ループ有効
  //slidesPerView: 3, // 一度に表示する枚数
  speed: 6000, // ループの時間
  //allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});